var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3701 34.8754C28.7551 34.8754 28.2451 34.3654 28.2451 33.7504V27.9004C28.2451 27.2854 28.7551 26.7754 29.3701 26.7754C29.9851 26.7754 30.4951 27.2854 30.4951 27.9004V33.7504C30.4951 34.3654 29.9851 34.8754 29.3701 34.8754Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3701 18.3C28.7551 18.3 28.2451 17.79 28.2451 17.175V14.25C28.2451 13.635 28.7551 13.125 29.3701 13.125C29.9851 13.125 30.4951 13.635 30.4951 14.25V17.175C30.4951 17.79 29.9851 18.3 29.3701 18.3Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6299 34.8742C18.0149 34.8742 17.5049 34.3642 17.5049 33.7492V30.8242C17.5049 30.2092 18.0149 29.6992 18.6299 29.6992C19.2449 29.6992 19.7549 30.2092 19.7549 30.8242V33.7492C19.7549 34.3642 19.2599 34.8742 18.6299 34.8742Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6299 21.225C18.0149 21.225 17.5049 20.715 17.5049 20.1V14.25C17.5049 13.635 18.0149 13.125 18.6299 13.125C19.2449 13.125 19.7549 13.635 19.7549 14.25V20.1C19.7549 20.715 19.2599 21.225 18.6299 21.225Z",
    fill: "#111827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3704 16.9941C27.1204 16.9941 25.2754 18.8241 25.2754 21.0741C25.2754 23.3241 27.1054 25.1691 29.3704 25.1691C31.6204 25.1691 33.4504 23.3391 33.4504 21.0741C33.4504 18.8091 31.6204 16.9941 29.3704 16.9941Z",
    fill: "#111827"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6298 22.8457C16.3798 22.8457 14.5498 24.6757 14.5498 26.9407C14.5498 29.2057 16.3798 31.0207 18.6298 31.0207C20.8798 31.0207 22.7248 29.1907 22.7248 26.9407C22.7248 24.6907 20.8948 22.8457 18.6298 22.8457Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting3);
export default __webpack_public_path__ + "static/media/setting3.2c4ecf5daf04b2963755079e6c0b9e06.svg";
export { ForwardRef as ReactComponent };